<script setup>
import { vInline } from "~/composables/useInlineEdit";

defineProps({ data: { type: Object, required: true } });
</script>

<template>
  <section class="py-12 md:py-16">
    <div class="container-x">
      <!-- `cms-content` is the single source of truth shared with the admin
           tiptap editor (admin/src/components/RichTextEditor.vue) so the
           published article looks exactly like what was typed. -->
      <article
        class="cms-content mx-auto max-w-prose"
        v-inline="'html'"
        v-html="data.html"
      />
    </div>
  </section>
</template>
